import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { DeviceCommentUpdate } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<
      unknown,
      Error,
      { probeId: string; payload: DeviceCommentUpdate },
      unknown
    >,
    'mutationKey' | 'mutationFn'
  >
}

export const usePatchWagnerProbeRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { probeId: string; payload: DeviceCommentUpdate }, unknown>(
    [Entities.WagnerProbes, 'patch'],
    async ({ probeId, payload }) => {
      const { data } = await api.v1AdminWagnerProbesProbeIdPatch(probeId, payload)
      return data
    },
    { ...options }
  )
}
